import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import $ from "jquery";

import "react-toastify/dist/ReactToastify.css";

class UserFundModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "this.props.user.id",
      walletData: [],
      dataStatus: false,
      // portfolioUsdt: 0,
      // portfolioInr: 0,
    };
    console.log("this.props", this.props);
  }

  componentWillReceiveProps(nextProps) {
    console.log("nextProps.currentRecord", nextProps.user);
    if (nextProps.currentRecord) {
      this.setState({
        walletData: nextProps.currentRecord.result,
        dataStatus: nextProps.currentRecord.success,
      });
    }
    if (nextProps.user) {
      this.setState({
        id: nextProps.user.id,
      });
    }
    // if (nextProps.portfolioRecord) {
    //   this.setState({
    //     portfolioUsdt: nextProps.portfolioRecord[0].USDT,
    //     portfolioInr: nextProps.portfolioRecord[0].INR,
    //   });
    // }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  tableDataHtml = () => {
    if (this.state.dataStatus== true ) {
      const html = [];
      const classThis = this;
      this.state.walletData && this.state.walletData.map((value, i) => {
        html.push(
          <tr>
            <td>{i + 1}</td>
            <td>{value.coinId?.shortName}</td>
            <td>
              {value.coinAmount != null
                ? value.coinAmount
                : 0}
            </td>
            <td>
            {value.ExchangeId && value.ExchangeId.ExchangenameId.exchangename}
            </td>
          </tr>
        );
      });
      return html;
    }
  };

  render() {
    const { errors } = this.state;
    return (
      <div>
        <div className="modal fade" id="update-fund-modal" data-reset="true" data-backdrop="static">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">User Balances</h4>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="portfolio-outer d-flex flex-wrap justify-content-between">
                  <h6>Portfolio (INR): {this.state.portfolioInr}</h6>
                  <h6>Portfolio (USDT): {this.state.portfolioUsdt}</h6>
                </div>
                <div className="user-balance-buy mb-3 ml-auto d-flex flex-wrap justify-content-between">
                  <button
                    className="btn btn-success"
                    data-toggle="modal"
                    data-target="#update-userbuy-modal"
                  >
                    Buy
                  </button>
                  <button
                    className="btn btn-danger"
                    data-toggle="modal"
                    data-target="#update-usersell-modal"
                  >
                    Sell
                  </button>
                  <button
                    className="btn btn-danger"
                    data-toggle="modal"
                    data-target="#update-userauto-modal"
                  >
                    Auto
                  </button>
                </div>
                <div className="portfolio-popup-outer d-flex flex-wrap justify-content-between align-items-center"></div>
                <table className="table w-100">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Currency</th>
                      <th>Main Wallet</th>
                      <th>Exchange</th>
                    </tr>
                  </thead>
                  <tbody>{this.tableDataHtml()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserFundModal.propTypes = {
  // userFundHistory: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps)(withRouter(UserFundModal));
